
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home'
import AboutRegioPlan from './pages/AboutRegionPlan';
import AboutUs from './pages/AboutUs';
import PlanningArea from './pages/PlanningArea';
import PlanningGroup from './pages/PlanningGroup';
import CommitteeAssignments from './pages/CommitteeAssignments';
import Meetings from './pages/Meetings';
import MeetingsArc from './pages/MeetingsArc';
import Calendar from './pages/Calendar';
import Downloads from './pages/Downloads';
import PlanningDocs from './pages/PlanningDocs';
import Links from './pages/Links';
import Footer from './components/Footer';
import ViewEvent from './pages/ViewEvent';
import './App.css';
import Navbar from './components/Sidebar';

function App() {
  return (
    <BrowserRouter>
      <div className='App'>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/AboutRegionPlan" element={<AboutRegioPlan />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/PlanningArea" element={<PlanningArea />} />
          <Route path="/PlanningGroup" element={<PlanningGroup />} />
          <Route path="/CommitteeAssignments" element={<CommitteeAssignments />} />
          <Route path="/Meetings" element={<Meetings />} />
          <Route path="/MeetingsArc" element={<MeetingsArc />} />
          <Route path="/Calendar" element={<Calendar />} />
          <Route path="/Downloads" element={<Downloads />} />
          <Route path="/PlanningDocs" element={<PlanningDocs />} />
          <Route path="/Links" element={<Links />} />
          <Route path="/ViewEvent/:id" element={<ViewEvent />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
